import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import {
  Info,
  ClipboardCheck,
  ArrowRight,
  GraduationCap,
  Clock,
  Users,
} from "lucide-react";

import DataFetcher from "../../hooks/DataFetcherPosgrados";
import Breadcumbs from "../../components/Breadcumbs";
import ConectUs from "../../components/ConectUs";
import BannerGeneral from "../../components/BannerGeneral";
import HeroBanner from "../../components/posgrados/HeroBanner";
import SubMenuAncla from "../../components/posgrados/SubMenuAncla";
import InfoCards from "../../components/posgrados/InfoCards";
import Modalidad from "../../components/posgrados/Modalidad";
import Duracion from "../../components/posgrados/Duracion";
import Campo from "../../components/posgrados/Campo";
import Malla from "../../components/posgrados/Malla";
import Facultad from "../../components/posgrados/Facultad";
import SubMenuAnclaGrado from "../../components/posgrados/SubMenuAnclaGrado";
import MallaGrado from "../../components/posgrados/MallaGrado";
import PosgradoPagos from "../../components/PosgradoPagos";
import HeroBannerGrado from "../../components/posgrados/HeroBannerGrado";
import EnLineaPagos from "../../components/Enlineapagos";
import Elementos from "../../components/posgrados/Elementos";
import Accordion from "../../components/Accordion";

// 1. URL CORRECTA: Pide "field_url_postulacion_en_linea" para que el Fetcher lo reciba y lo procese
const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/carrera/f4e28290-4962-4ac3-aca8-24033ca2c7d4" +
  "?include=field_imagen_portada.field_media_image,field_brochure,field_malla_curricular_linea," +
  "field_imagen_perfil_ingreso.field_media_image," +
  "field_imagen_campo_ocupacional.field_media_image," +
  "field_imagen_director.field_media_image," +
  "field_imagen_perfil_profesional.field_media_image," +
  "field_nuestros_docentes.field_imagen_docente.field_media_image" +
  "&fields[node--carrera]=title,field_brochure,field_malla_curricular_linea,field_texto_portada,field_imagen_portada,field_publicado,field_url_postulacion_en_linea,field_publicado_presencial,field_url_postulacion_presencial," +
  "field_titulo,field_facultad,field_descripcion_malla,field_modalidad,field_etiqueta_modalidad,field_costo_en_linea,field_descripcion_carrera,field_imagen_campo_ocupacional,field_campo_ocupacional," +
  "field_duracion,field_inicio_clases,field_resolucion,field_etiqueta_modalidad,field_imagen_perfil_profesional,field_imagen_perfil_ingreso,field_perfil_de_ingreso,field_malla_curricular,field_perfil_profesional," +
  "field_por_que_estudiar,field_texto_director,field_imagen_director,field_nuestros_docentes,field_requisitos_de_postulacion,field_proceso_matricula_presenci," +
  "field_titulo_elementos,field_diplomados,field_certificaciones,field_microcredenciales," +
  "field_bloque1,field_bloque2" +
  "&fields[node--docente]=title,field_imagen_docente,field_contenido," +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

const DataDisplay = ({ data }) => {
  const fadeUp = {
    initial: { opacity: 0, y: 40 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 },
  };

  return (
    <div className="bg-white overflow-hidden mt-16">
      {/* HERO */}
      <HeroBannerGrado
        image={data?.imagen_portada}
        content={data?.field_texto_portada}
        showApply={data?.field_publicado}
        applyUrl={data?.enlace_enlinea?.uri}
        showApplyPresencial={data?.field_publicado_presencial}
        applyUrlPresencial={data?.field_url_postulacion_presencial?.uri}
        brochure={data.brochure}
      />
      {/* BREADCRUMBS */}
      <div className="border-b border-slate-200 bg-white">
        <div className="mb-6">
          <Breadcumbs
            content={
              <div className="flex items-center gap-2 text-sm">
                <NavLink to="/en-linea">En línea</NavLink>
                <span>/</span>
                <NavLink to="/carrera-turismo-gastronomia">
                  Negocios Turísticos y Gastronómicos
                </NavLink>
              </div>
            }
          />
        </div>
      </div>

      {/* INFO CARDS  */}
      <InfoCards
        titulo={data.titulo_recibir}
        inversion={data.precio_enlinea}
        inicio={data.inicio}
        facultad={
          <>
            <Facultad value={data.facultad}></Facultad>
          </>
        }
        duracion={
          <>
            <Duracion value={data.duracion}></Duracion>
          </>
        }
        modalidad={
          <>
            <Modalidad value={data.modalidad}></Modalidad>
            <div
              dangerouslySetInnerHTML={{
                __html: data.etiqueta_modalidad,
              }}
            />
          </>
        }
        resolucion={
          <div
            dangerouslySetInnerHTML={{
              __html: data.resolucion,
            }}
          />
        }
      ></InfoCards>

      {data.descripcion_carrera && (
        <>
          <div className="max-w-6xl x-6 m-auto [&_h2]:font-bold py-24">
            <div
              dangerouslySetInnerHTML={{
                __html: data.descripcion_carrera,
              }}
            />
          </div>
        </>
      )}

      {/* PERFIL profesional */}
      <section id="profesional" className="py-24  ">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-20 items-start py-4">
          <motion.div {...fadeUp}>
            <div className="px-8 lg:px-0">
              <div
                className=" 
                [&_h2]:font-bold"
                dangerouslySetInnerHTML={{
                  __html: data.perfil_profesional,
                }}
              />
            </div>
          </motion.div>

          <motion.div {...fadeUp}>
            <img
              src={data.imagen_perfilprofesional}
              alt="Perfil"
              className="w-full h-[400px] object-cover rounded-3xl shadow-2xl"
            />
          </motion.div>
        </div>
      </section>

      {/*campo ocupacional */}
      <section id="campo" className="py-24  bg-slate-50">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-20 items-start py-4">
          <motion.div {...fadeUp}>
            <img
              src={data.imagen_campo}
              alt="Perfil"
              className="w-full h-[500px] object-cover rounded-3xl shadow-2xl"
            />
          </motion.div>

          <motion.div {...fadeUp}>
            <div className="px-8 lg:px-0">
              <div
                className=" 
                [&_h2]:font-bold"
                dangerouslySetInnerHTML={{
                  __html: data.campo_ocupacional,
                }}
              />
            </div>
          </motion.div>
        </div>
      </section>

      <MallaGrado
        title={data.descripcion_malla}
        content={data.malla}
      ></MallaGrado>

      {data.titulo_elementos && (
        <>
          <Elementos
            titulo={data.titulo_elementos}
            diplomados={data.diplomados}
            certificaciones={data.certificaciones}
            microcredenciales={data.microcredenciales}
          ></Elementos>
        </>
      )}

      {/* El contenedor principal solo se renderiza si al menos uno de los bloques tiene información */}
      {(data.bloque1 || data.bloque2) && (
        <div>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35 }}
          >
            <h2 className="text-center max-w-3xl m-auto font-bold mb-6">
              {" "}
              Una experiencia de aprendizaje{" "}
              <span className="font-montserrat text-[#febe10]">flexible</span>
            </h2>
          </motion.div>
          <div className="flex flex-wrap justify-center gap-6 w-full max-w-6xl mx-auto pb-24">
            {/* Columna 1: Aprendizaje Asíncrono (Bloque 1) */}
            {data.bloque1 && (
              <motion.div
                className="w-full md:w-[calc(50%-12px)] p-6 bg-white rounded-xl border border-slate-200/80 shadow-sm"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.35, delay: 0.5 }}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2 bg-slate-100 rounded-lg flex-shrink-0">
                    <Clock className="w-6 h-6" style={{ color: "#004270" }} />
                  </div>
                </div>

                <div
                  className="[&_h2]:font-bold "
                  dangerouslySetInnerHTML={{
                    __html: data.bloque1,
                  }}
                />
              </motion.div>
            )}

            {/* Columna 2: Aprendizaje Síncrono (Bloque 2) */}
            {data.bloque2 && (
              <motion.div
                className="w-full md:w-[calc(50%-12px)] p-6 bg-white rounded-xl border border-slate-200/80 shadow-sm"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.35, delay: 1 }}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2 bg-slate-100 rounded-lg flex-shrink-0">
                    <Users className="w-6 h-6" style={{ color: "#004270" }} />
                  </div>
                </div>
                <div
                  className="[&_h2]:font-bold "
                  dangerouslySetInnerHTML={{
                    __html: data.bloque2,
                  }}
                />
              </motion.div>
            )}
          </div>
        </div>
      )}

      <section id="estudiar" className="bluebg">
        <div className="max-w-5xl mx-auto px-6 py-24">
          {/* Encabezado */}

          <div className="flex items-center gap-4">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#febe10] shadow-lg">
              <GraduationCap className="h-7 w-7 text-[#004270]" />
            </div>
          </div>

          {/* Contenido */}
          <div
            className="
        prose prose-lg max-w-none
        [&_h2]:font-bold
         [&_h2]:mb-6

        [&_img]:rounded-2xl
        [&_img]:shadow-lg
      "
            dangerouslySetInnerHTML={{
              __html: data.estudiar,
            }}
          />
        </div>
      </section>

      {/* DIRECTOR */}

      {data.director && (
        <section className="py-24 bg-white">
          <div className="max-w-6xl mx-auto  grid lg:grid-cols-2 gap-20 items-center">
            <motion.div {...fadeUp}>
              <img
                src={data.imagen_director}
                alt="Director"
                className="w-auto h-[550px] object-cover rounded-3xl shadow-2xl"
              />
            </motion.div>

            <motion.div className="px-10 lg:px-0" {...fadeUp}>
              <span className="text-gray-600 uppercase ">
                Director del programa
              </span>

              <div
                className="  mt-6 link-with-arrow-1 "
                dangerouslySetInnerHTML={{
                  __html: data.director,
                }}
              />
            </motion.div>
          </div>
        </section>
      )}

      {/* DOCENTES */}
      {data.nuestros_docentes && data.nuestros_docentes.length > 0 && (
        <section id="docentes" className="pt-10 pb-10">
          <div className="max-w-6xl mx-auto pb-10  ">
            <motion.div {...fadeUp} className="text-center mb-10">
              <h2 className="  font-bold ">Nuestros docentes</h2>
            </motion.div>

            <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8">
              {data.nuestros_docentes.map((profe, index) => (
                <motion.div
                  key={profe.id}
                  {...fadeUp}
                  transition={{
                    duration: 0.5,
                    delay: index * 0.1,
                  }}
                  whileHover={{
                    y: -10,
                  }}
                  className="bg-white rounded-3xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-2xl transition-all"
                >
                  <img
                    src={profe.foto}
                    alt={profe.nombre}
                    className="w-full h-80 object-cover"
                  />

                  <div className="px-8">
                    <h3 className="text-lg font-bold">{profe.nombre}</h3>

                    <div
                      className=" link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: profe.contenido,
                      }}
                    />
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/*REQUISITOS */}
      <section
        id="proceso"
        className=" mt-10 max-w-6xl mx-auto rounded-2xl border border-slate-200 bg-white p-6 shadow-sm"
      >
        <div className="px-12">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gray-100 text-[#004270]">
            <ClipboardCheck className="h-6 w-6" />
          </div>
          <div
            className=" 
            [&_h2]:font-bold
                [&_h3]:text-[#febe10]
                [&_h3]:text-lg
                [&_h3_strong]:text-lg
                 [&_h3]:m-0
                  [&_h3]:p-0"
            dangerouslySetInnerHTML={{
              __html: data.requisitos,
            }}
          />{" "}
        </div>

        {data.field_publicado && (
          <div>
            <div className=" mt-10 px-12">
              <div className="flex">
                <a
                  href={data.enlace_enlinea?.uri}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-amber-400 hover:bg-blue-700 hover:text-white text-[#004270] px-8 py-4 rounded-2xl font-semibold transition-all flex items-center gap-2 shadow-2xl"
                >
                  Matricúlate ahora
                  <ArrowRight size={18} />
                </a>
              </div>
              <div className="mt-10">
                <Accordion
                  title="Conoce nuestros descuentos y becas"
                  content={
                    <>
                      <div className="mt-10">
                        <EnLineaPagos />
                      </div>{" "}
                    </>
                  }
                ></Accordion>{" "}
              </div>
            </div>
          </div>
        )}
      </section>

      {data.requisitos_presencial && (
        <section
          id="proceso"
          className="mt-10 max-w-6xl mx-auto rounded-2xl border border-slate-200 bg-white p-6 shadow-sm"
        >
          <div className="px-12">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gray-100 text-[#004270]">
              <ClipboardCheck className="h-6 w-6" />
            </div>
            <div
              className=" 
                [&_h2]:font-bold
                [&_h3]:text-[#febe10]
                [&_h3]:text-lg
                [&_h3_strong]:text-lg
                      [&_h3]:m-0
                  [&_h3]:p-0"
              dangerouslySetInnerHTML={{
                __html: data.requisitos_presencial,
              }}
            />{" "}
          </div>

          {data.field_publicado_presencial && (
            <div>
              <div className="flex mt-10 px-12">
                <a
                  href={data.enlace_presencial?.uri}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-amber-400 hover:bg-blue-700 hover:text-white text-[#004270] px-8 py-4 rounded-2xl font-semibold transition-all flex items-center gap-2 shadow-2xl"
                >
                  Inscríbete ahora
                  <ArrowRight size={18} />
                </a>
              </div>
              <div className="mt-10"></div>
            </div>
          )}
        </section>
      )}

      
    </div>
  );
};

export default function CarreraNegociosTuristicos() {
  return (
    <>
      <SubMenuAnclaGrado></SubMenuAnclaGrado>
      <DataFetcher url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcher>

      <div className="mt-10 py-8">
        <ConectUs
          lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes."
          instagram="https://www.instagram.com/utplenlinea/"
          facebook="https://www.facebook.com/utplenlinea/"
          tiktok="https://www.tiktok.com/@utplenlinea"
        ></ConectUs>
      </div>

      <BannerGeneral />
    </>
  );
}
